module.exports = __webpack_public_path__ + "media/images/iconLockOpen-d4a7a57e3a20b679fe713a257c0c593d.png";